import { render, staticRenderFns } from "./voucherCreateCrmBuyData.vue?vue&type=template&id=399683c4&scoped=true&"
import script from "./voucherCreateCrmBuyData.vue?vue&type=script&lang=js&"
export * from "./voucherCreateCrmBuyData.vue?vue&type=script&lang=js&"
import style0 from "./voucherCreateCrmBuyData.vue?vue&type=style&index=0&id=399683c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399683c4",
  null
  
)

export default component.exports